import ApiRequest from "./apiRequest";
import {setSession} from "./session";

class LoginService {
  /**
   * POST /auth/authenticate. On success the backend sets the HttpOnly session
   * cookies and returns the session payload (user, role, expires_at) — the JWT
   * itself is never exposed to JS.
   */
  static async logIn(payload) {
    const data = await ApiRequest.apiRequest({method: 'POST', url: 'auth/authenticate', body: payload});
    if (data && data.user) {
      setSession(data);
    }
    return data;
  }

  /** GET /auth/me — session boot check (401 response is mapped to an error object). */
  static async me() {
    const data = await ApiRequest.apiRequest({method: 'GET', url: 'auth/me'});
    if (data && data.user) {
      setSession(data);
    }
    return data;
  }

  /** POST /auth/logout — clears the session cookies server-side. */
  static async logOut() {
    return ApiRequest.apiRequest({method: 'POST', url: 'auth/logout', noResponse: true});
  }
}

export default LoginService;
